export enum DomaineCode {
    VIN = 'VIN',
    POMME = 'POMME',
    PORCIN = 'PORCIN',
    BOVIN = 'BOVIN',
    VIANDE = 'VIANDE'
}
